import type { MenuSection } from '@1js/acui-menu/lib/components/MenuDefinition';
import type { RibbonButtonProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon';
import { createMailAppButton } from '../../util/createMailRibbonButton';
import { getQuickSteps } from 'owa-mail-quick-steps-store/lib/util/getQuickSteps';
import type { QuickStepItem } from 'owa-mail-quick-steps-store/lib/store/schema/QuickStepItem';
import { onManageQuickStepsClicked, onExecuteQuickStep } from '../../util/onQuickStepCommandAction';
import { getControlInfo } from 'owa-mail-ribbon-utils';
import { MailRibbonControlId } from 'owa-ribbon-ids';
import { getIsQuickStepDisabled } from '../../util/getIsQuickStepDisabled';
import { getIconNameFromIconId } from 'owa-mail-quick-steps-store/lib/util/getQuickStepIcon';

export default function getQuickStepsSections(): MenuSection[] {
    return [{ controls: getActionsSection() }, { controls: getMoreSection() }];
}

function getActionsSection(): RibbonButtonProps[] {
    let actions: RibbonButtonProps[] = [];

    const quickSteps: QuickStepItem[] = getQuickSteps();
    quickSteps.forEach(step => {
        actions.push(
            createMailAppButton(
                step.id,
                step.name,
                step.description,
                false,
                onExecuteQuickStep(step.id),
                undefined,
                getIconNameFromIconId(step.iconId),
                undefined /*iconColor*/,
                undefined /*styles*/,
                {
                    disabled: getIsQuickStepDisabled(step.actions),
                }
            )
        );
    });
    return actions;
}

function getMoreSection() {
    const manageControlInfo = getControlInfo(MailRibbonControlId.ManageQuickSteps);
    return [
        createMailAppButton(
            MailRibbonControlId.ManageQuickSteps,
            manageControlInfo.text,
            manageControlInfo.tooltip,
            false /*isPopout*/,
            onManageQuickStepsClicked,
            undefined /*keytip*/,
            manageControlInfo.iconName
        ),
    ];
}
